import { GlobalToken } from 'antd';
import styled from 'styled-components';

export const HistoryTestWrapper = styled.div<{ theme: { token: GlobalToken }; $isMobile: boolean }>`
  .date-selector-options {
    display: flex;
  }

  .date-value-wrapper {
    margin-left: ${({ $isMobile }) => ($isMobile ? '' : '10px')};
    margin-top: ${({ $isMobile }) => ($isMobile ? '511px' : '')};
  }

  .date-value {
    color: ${({ theme: { token } }) => token.colorPrimary};
    cursor: pointer;
    display: inline-flex;
    align-items: center;
    gap: 4px;
    margin-left: ${({ $isMobile }) => ($isMobile ? '2px' : '')};
  }
`;

export const DateSelectorOptions = styled.p`
  display: flex;
`;

export const LineBreak = styled.div<{ $height: number }>`
  height: ${({ $height }) => `${$height}px`};
`;
